<template>
  <v-file-input
    v-model="model"
    v-bind="$attrs"
    :accept="accept"
    :chips="chips"
    :clearable="clearable"
    :counter="counter"
    :dense="dense"
    :hint="hint"
    :label="label"
    :multiple="multiple"
    :persistent-hint="persistentHint"
    :rules="rules"
    outlined
    rounded
  ></v-file-input>
</template>

<script>
export default {
  name: "CVIFileInput",

  props: {
    accept: {
      type: String,
      default: "*/*",
    },
    chips: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    counter: {
      type: [Boolean, Number, String],
      default: undefined,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hint: {
      type: String,
      default: undefined,
    },
    label: {
      type: String,
      default: undefined,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    persistentHint: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    validator: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
    rules() {
      const rules = [...this.validator];

      if (this.required) {
        rules.push((v) => {
          if (Array.isArray(v)) {
            return v.length > 0 || "Este campo é obrigatório";
          }
          return !!v || "Este campo é obrigatório";
        });
      }

      return rules;
    },
  },
};
</script>
